import { render, staticRenderFns } from "./form-input-group.vue?vue&type=template&id=36f56384"
import script from "./form-input-group.vue?vue&type=script&lang=js"
export * from "./form-input-group.vue?vue&type=script&lang=js"
import style0 from "./form-input-group.vue?vue&type=style&index=0&id=36f56384&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f56384')) {
      api.createRecord('36f56384', component.options)
    } else {
      api.reload('36f56384', component.options)
    }
    module.hot.accept("./form-input-group.vue?vue&type=template&id=36f56384", function () {
      api.rerender('36f56384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/form-input-group.vue"
export default component.exports